import React from 'react';
import Bottom from './components/Bottom';
import Float from './components/Float';

const Footer = (props) => {
  return (
    <center>
      <Bottom />
      <Float />
    </center>
  );
}

export default Footer;